/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
// import Modal from "../common_modal/Modal";
// import GRID_SELECT_LAYER from "./GRID_SELECT_LAYER";

/*REDUX*/
import {
  set_value_toolbox,
  status_toolbox,
} from "../../App/actions/toolboxActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import { Dropdown } from "../reuseable";
import { Close } from "@material-ui/icons";

/*CONST*/

class GRID_STEP_1 extends Component {
  state = {
    // modal_select: false,
  };

  toggle_select = (event) => {
    const name = event?.target?.name;
    if (name) this.props.set_value_toolbox({ key: "select_mode", value: name });
    this.setState({
      modal_select: !this.state.modal_select,
    });
  };

  on_change = (layer_id, select_mode) => {
    const toolbox = this.props.toolbox;

    const key = select_mode === "point" ? "layer_point_ids" : "layer_polygon_ids";

    if (layer_id) {
      const { toolbox_grid_object } = toolbox || {};
      const ids = toolbox_grid_object?.[key];
      let new_ids = [...ids];

      if (ids.includes(layer_id)) {
        new_ids = ids.filter(id => id !== layer_id)
      } else {
        new_ids.push(layer_id)
      }

      const new_toolbox_grid_object = {
        ...toolbox_grid_object,
        [key]: new_ids
      }

      this.props.set_value_toolbox({
        key: "toolbox_grid_object",
        value: new_toolbox_grid_object,
      });

      if (key === "layer_point_ids" && new_ids.length > 0) {
        const polygon_ids = toolbox_grid_object?.["layer_polygon_ids"];
        if (polygon_ids?.length > 0 && new_ids?.length > 0) this.props.set_step(1);
      } else if (key === "layer_polygon_ids" && new_ids.length > 0) {
        const point_ids = toolbox_grid_object?.["layer_point_ids"];
        if (point_ids?.length > 0 && new_ids?.length > 0) this.props.set_step(1);
      }
    }
  };

  selected_pill = (key, label, callback) => {
    const name = label.replace(/_/g, " ");
    return <div
      key={key}
      className="label_pill"
      style={{
        border: "1px solid #ABABAB80",
        backgroundColor: "#F1F1F1",
        textWrap: "nowrap",
      }}
    >
      <span
        style={{
          maxWidth: "220px",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {name}
      </span>
      <button
        className="center_perfect"
        onClick={() => callback(key)}
        style={{
          borderRadius: "100%",
          border: "1px solid black",
          width: "14px",
          height: "14px",
        }}>
        <Close style={{ width: "10px", height: "10px" }} />
      </button>
    </div>
  }

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    // const { modal_select } = this.state;

    //global props
    const {
      //output
      toolbox_grid_object,
      layer_list_point_obj,
      layer_list_polygon_obj,
    } = this.props.toolbox;

    const {
      //input
      layer_point_ids,
      layer_polygon_ids,
    } = toolbox_grid_object;

    //content
    // const modal_select_content = modal_select && (
    //   <Modal
    //     modalSize="medium"
    //     isOpen={modal_select}
    //     onClose={this.toggle_select}
    //   >
    //     <div className="box-body" id="box-body">
    //       <GRID_SELECT_LAYER toggle_select={this.toggle_select} />
    //     </div>
    //   </Modal>
    // );


    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          margin: "0px 20px 15px 20px",
        }}
      >
        {/* step 1 */}
        <section>
          <h2 className="text_bold">
            {dict?.["Select layer"]?.[language]} (Point)
          </h2>
          <Dropdown
            placeholder={dict["Select"][language]}
            filter_on
            is_enable_empty={false}
            onChange={(layer_id) => {
              this.on_change(layer_id, "point");
            }}
            option_style={{
              maxWidth: "270px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              display: "inline-block"
            }}
          >
            {Object.keys(layer_list_point_obj)?.map((layer_id) => {
              return (
                <option key={layer_id} value={layer_id}>
                  {layer_list_point_obj?.[layer_id]}
                </option>
              );
            })}
          </Dropdown>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginTop: "10px", maxHeight: "150px", overflowY: "auto" }}>
            {layer_point_ids?.map(id => this.selected_pill(id, layer_list_point_obj[id], () => { this.on_change(id, "point"); }))}
          </div>

        </section>
        <section>
          <h2 className="text_bold">
            {dict?.["Select layer"]?.[language]} (Polygon)
          </h2>
          <Dropdown
            placeholder={dict["Select"][language]}
            filter_on
            is_enable_empty={false}
            onChange={(layer_id) => {
              this.on_change(layer_id, "polygon");
            }}
            option_style={{
              maxWidth: "270px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              display: "inline-block"
            }}
          >
            {Object.keys(layer_list_polygon_obj)?.map((layer_id) => {
              return (
                <option key={layer_id} value={layer_id}>
                  {layer_list_polygon_obj?.[layer_id]}
                </option>
              );
            })}
          </Dropdown>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginTop: "10px", maxHeight: "150px", overflowY: "auto" }}>
            {layer_polygon_ids?.map(id => this.selected_pill(id, layer_list_polygon_obj[id], () => { this.on_change(id, "polygon"); }))}
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  toolbox: state.toolbox,
  map: state.map,
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  set_value_toolbox,
  status_toolbox,
})(GRID_STEP_1);
